"use client"

import React from "react"

const SPANISH_TEXT = {
  genericError: "Ocurrió un error. Por favor, inténtalo de nuevo.",
}

interface FormContainerProps {
  children: React.ReactNode
  formError?: string | null
  onSubmit: (e: React.FormEvent) => void
}

const FormContainer: React.FC<FormContainerProps> = ({ children, formError, onSubmit }) => {
  return (
    <div className="flex-1">
      <form id="native-form" onSubmit={onSubmit}>
        {children}

        {formError && (
          <div className="mb-3 text-center text-sm text-red-500">{formError === "generic" ? SPANISH_TEXT.genericError : formError}</div>
        )}
      </form>
    </div>
  )
}

export default FormContainer
